import { render, staticRenderFns } from "./Opcionales.vue?vue&type=template&id=6b8743b7&scoped=true&"
import script from "./Opcionales.vue?vue&type=script&lang=js&"
export * from "./Opcionales.vue?vue&type=script&lang=js&"
import style0 from "./Opcionales.vue?vue&type=style&index=0&id=6b8743b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8743b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
